module.exports = __webpack_public_path__ + "img/icon-component-label_GoodsAndImage.2f08b8c7.svg";